type PersonPortraitProps = {
  name: string;
  initial: string;
  photoSrc?: string;
};

/**
 * Shared "who you are booking with" visual. Every person gets the exact same
 * slot and size: a real photo when one exists, otherwise a placeholder in the
 * same brush/paper language so a missing photo never reads as a lesser
 * presence than someone else's portrait.
 */
export function PersonPortrait({ name, initial, photoSrc }: PersonPortraitProps) {
  if (photoSrc) {
    return (
      <figure className="booking-context__portrait">
        <img src={photoSrc} alt={name} />
      </figure>
    );
  }

  return (
    <figure
      className="booking-context__portrait booking-context__portrait--placeholder"
      aria-label={`Foto von ${name} folgt`}
    >
      <span aria-hidden="true">{initial}</span>
    </figure>
  );
}
